var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3302 0.117155C15.2164 0.046898 15.0866 0.00684909 14.9531 0.000803333C14.8195 -0.00524243 14.6866 0.0229152 14.567 0.082608L8.45143 3.14079H3.92578C2.8846 3.14079 1.88606 3.5544 1.14984 4.29063C0.413608 5.02686 0 6.0254 0 7.06658C0 8.10776 0.413608 9.1063 1.14984 9.84253C1.88606 10.5788 2.8846 10.9924 3.92578 10.9924H8.45143L14.567 14.0545C14.687 14.1145 14.8205 14.1427 14.9545 14.1364C15.0885 14.1302 15.2187 14.0897 15.3327 14.0188C15.4466 13.948 15.5405 13.8491 15.6054 13.7316C15.6702 13.6141 15.7039 13.482 15.7031 13.3478V0.785323C15.7031 0.651388 15.6688 0.519682 15.6036 0.40273C15.5383 0.285779 15.4442 0.187471 15.3302 0.117155Z",
    fill: "#2A1812"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4883 4.71106V9.422C17.113 9.422 17.7121 9.17384 18.1539 8.7321C18.5956 8.29036 18.8438 7.69124 18.8438 7.06653C18.8438 6.44182 18.5956 5.8427 18.1539 5.40096C17.7121 4.95922 17.113 4.71106 16.4883 4.71106Z",
    fill: "#2A1812"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96291 12.5626H4.56396L6.39652 17.0726C6.56267 17.4428 6.86568 17.7343 7.24205 17.886C7.61841 18.0378 8.0389 18.0379 8.41536 17.8864C8.79183 17.735 9.09504 17.4436 9.26142 17.0735C9.42781 16.7034 9.44446 16.2832 9.30788 15.9011L7.96291 12.5626Z",
    fill: "#2A1812"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeaker);
export default __webpack_public_path__ + "static/media/icon-speaker.c6f376a2929b8e4dfec54d938bdf8525.svg";
export { ForwardRef as ReactComponent };